import { useEffect } from "react";
import { createPortal } from "react-dom";

/**
 * Viewport-centered modal rendered via a portal to document.body so it escapes any
 * transformed/animated ancestor (e.g. .animate-fade-up), which would otherwise trap
 * position:fixed elements and push them out of view.
 */
export default function Modal({ children, onClose, className = "" }) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape" && onClose) onClose(); };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onClose]);

  return createPortal(
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm ${className}`}
      onMouseDown={(e) => { if (e.target === e.currentTarget && onClose) onClose(); }}
    >
      {children}
    </div>,
    document.body
  );
}
